import axios from "axios";
import moment from "moment";

export function parseCarbonDate(carbonDate) {
  if (carbonDate) {
    const year = carbonDate.substring(0, 4);
    const mounth = carbonDate.substring(5, 7);
    const day = carbonDate.substring(8, 10);
    return `${day}/${mounth}/${year}`;
  }
  return "07/07/2007";
}

/**
 * get the quantity of assets in the user account (by JSON)
 * @param {JSON} assets
 * @returns {Number} quantity of assets in the user account.
 */
export function parseQntAssetsJSON(assets) {
  try {
    let parsedAssets = JSON.parse(assets);
    return parsedAssets.length;
  } catch (error) {
    return 0;
  }
}

export function limitcharactersInString(string, limit) {
  if (string) {
    if (string.length > limit) {
      return string.substring(0, limit) + "...";
    } else {
      return string;
    }
  }
  return "";
}

export function getActualTime() {
  let date = new Date();
  let hours = date.getHours();
  let minutes = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
  const hoursAndMinutes = hours + ":" + minutes;
  return hoursAndMinutes;
}

export function getTimeDiferenceTitle(endDate) {
  let output = "alguns segundos";

  const availableDifferences = [
    {
      diffValue: "minutes",
      pluralTitle: "minutos",
      singularTitle: "minuto",
    },
    {
      diffValue: "hours",
      pluralTitle: "horas",
      singularTitle: "hora",
    },
    {
      diffValue: "days",
      pluralTitle: "dias",
      singularTitle: "dia",
    },
    {
      diffValue: "weeks",
      pluralTitle: "semanas",
      singularTitle: "semana",
    },
    {
      diffValue: "months",
      pluralTitle: "meses",
      singularTitle: "mês",
    },
    {
      diffValue: "years",
      pluralTitle: "anos",
      singularTitle: "ano",
    },
  ];

  availableDifferences.forEach((difference) => {
    const diffValue = moment().diff(endDate, difference.diffValue);

    if (diffValue === 1) {
      output = `${diffValue} ${difference.singularTitle}`;
    } else if (diffValue > 1) {
      output = `${diffValue} ${difference.pluralTitle}`;
    }
  });

  return output;
}

export function encodePairId(pairId) {
  const characters = pairId.split("");
  const keys = [
    {
      encoded: "f",
      decoded: "0",
    },
    {
      encoded: "a",
      decoded: "1",
    },
    {
      encoded: "t",
      decoded: "2",
    },
    {
      encoded: "h",
      decoded: "3",
    },
    {
      encoded: "e",
      decoded: "4",
    },
    {
      encoded: "r",
      decoded: "5",
    },
    {
      encoded: "s",
      decoded: "6",
    },
    {
      encoded: "o",
      decoded: "7",
    },
    {
      encoded: "n",
      decoded: "8",
    },
    {
      encoded: "7",
      decoded: "9",
    },
  ];

  const encodedCharacters = characters.map((character) => {
    const key = keys.find((key) => key.decoded === character);

    return key.encoded;
  });

  return encodedCharacters.join("");
}

export function decodePairId(encodedPairId) {
  const characters = encodedPairId.split("");
  const keys = [
    {
      encoded: "f",
      decoded: "0",
    },
    {
      encoded: "a",
      decoded: "1",
    },
    {
      encoded: "t",
      decoded: "2",
    },
    {
      encoded: "h",
      decoded: "3",
    },
    {
      encoded: "e",
      decoded: "4",
    },
    {
      encoded: "r",
      decoded: "5",
    },
    {
      encoded: "s",
      decoded: "6",
    },
    {
      encoded: "o",
      decoded: "7",
    },
    {
      encoded: "n",
      decoded: "8",
    },
    {
      encoded: "7",
      decoded: "9",
    },
  ];

  const decodedCharacters = characters.map((character) => {
    const key = keys.find((key) => key.encoded === character);

    return key.decoded;
  });

  return decodedCharacters.join("");
}

export function parseInvestorTypeInt(num) {
  switch (num) {
    case 0:
      return "Day Trader";
    case 1:
      return "Swing Trader";
    case 2:
      return "Buy and Holder";
    case 3:
      return "Position Trader";
    default:
      return null;
  }
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function parseInvestorTypeSimple(num) {
  switch (num) {
    case 0:
      return "Agressivo";
    case 1:
      return "Moderado";
    case 2:
      return "Conservador";
    default:
      return null;
  }
}

export function parseAssetTypeInt(num) {
  switch (num) {
    case 1:
      return "Ações";
    case 2:
      return "Forex";
    case 3:
      return "Criptomoeda";
    case 4:
      return "Fundos imobiliários";
    default:
      return null;
  }
}

export function parseCountryCodeInt(num) {
  switch (num) {
    case 32:
      return "Brazil";
    case 17:
      return "Alemanha";
    case 29:
      return "Argentina";
    case 25:
      return "Australia";
    case 6:
      return "Canadá";
    case 5:
      return "EUA";
    case 89:
      return "Espanha";
    case 22:
      return "França";
    case 35:
      return "Japão";
    case 14:
      return "Índia";
    case 72:
      return "Europa";
    case 4:
      return "UK";
    case 38:
      return "Portugal";
    default:
      return null;
  }
}

export function parseIndicationFundamentalist(num, theme) {
  switch (num) {
    case 0:
      return {
        name: "Imparcial",
        color: "#424242",
        backgroundColor: null,
        progressBar: {
          variant: "warning",
          percent: 50,
        },
      };
    case 1:
      return {
        name: "Bom",
        color: "#43a047",
        backgroundColor: null,
        progressBar: {
          variant: "success",
          percent: 70,
        },
      };
    case 2:
      return {
        name: "Ruim",
        color: "#ef5350",
        backgroundColor: null,
        progressBar: {
          variant: "danger",
          percent: 30,
        },
      };
    case 3:
      return {
        name: "Excelente",
        color: "#2e7d32",
        backgroundColor: theme === "dark" ? "#a3e63511" : "#e8f5e9",
        progressBar: {
          variant: "success",
          percent: 100,
        },
      };
    case 4:
      return {
        name: "Péssimo",
        color: "#d32f2f",
        backgroundColor: theme === "dark" ? "#f8717111" : "#ffebee",
        progressBar: {
          variant: "danger",
          percent: 10,
        },
      };
    case 5:
      return {
        name: "Alerta leve",
        color: "#fdd835",
        backgroundColor: theme === "dark" ? "#fdd83511" : "#fffde7",
        progressBar: {
          variant: "warning",
          percent: 40,
        },
      };
    case 6:
      return {
        name: "Alerta leve",
        color: "#fdd835",
        backgroundColor: theme === "dark" ? "#fdd83511" : "#fffde7",
        progressBar: {
          variant: "warning",
          percent: 40,
        },
      };
    default:
      return {
        name: "Imparcial",
        color: "#fdd835",
        backgroundColor: theme === "dark" ? "#fdd83511" : "#fffde7",
        progressBar: {
          variant: "warning",
          percent: 50,
        },
      };
  }
}

export function techIndicationToDisplayable(indication, theme) {
  switch (indication) {
    case 0:
      return {
        name: "Imparcial",
        color: "#424242",
        backgroundColor: null,
        progressBar: {
          variant: "warning",
          percent: 50,
        },
      };
    case 1:
      return {
        name: "Compra",
        color: "#43a047",
        backgroundColor: null,
        progressBar: {
          variant: "success",
          percent: 70,
        },
      };
    case 2:
      return {
        name: "Venda",
        color: "#ef5350",
        backgroundColor: null,
        progressBar: {
          variant: "danger",
          percent: 30,
        },
      };
    case 3:
      return {
        name: "Forte compra",
        color: "#2e7d32",
        backgroundColor: theme === "dark" ? "#a3e63511" : "#e8f5e9",
        progressBar: {
          variant: "success",
          percent: 100,
        },
      };
    case 4:
      return {
        name: "Forte venda",
        color: "#d32f2f",
        backgroundColor: theme === "dark" ? "#f8717111" : "#ffebee",
        progressBar: {
          variant: "danger",
          percent: 10,
        },
      };
    case 5:
    case 6:
      return {
        name: "Alerta leve",
        color: "#fdd835",
        backgroundColor: theme === "dark" ? "#fdd83511" : "#fffde7",
        progressBar: {
          variant: "warning",
          percent: 40,
        },
      };
    default:
      return {
        name: "Indefinido",
        color: "#424242",
        backgroundColor: null,
        progressBar: {
          variant: "warning",
          percent: 0,
        },
      };
  }
}

export function parseNewsSentiment(num) {
  switch (num) {
    case 0:
      return <span style={{ color: "#424242" }}>Imparcial</span>;
    case 1:
      return <span style={{ color: "#43a047" }}>Otimista</span>;
    case 2:
      return <span style={{ color: "#f44336" }}>Pessimista</span>;
    default:
      <span style={{ color: "#424242" }}>Imparcial</span>;
  }
}

const resources = {};

const makeRequestCreator = () => {
  let cancel;

  return async (query) => {
    if (cancel) {
      cancel.cancel();
    }

    cancel = axios.CancelToken.source();
    try {
      if (resources[query]) {
        return resources[query];
      }
      const res = await axios(query, { cancelToken: cancel.token });

      const result = res;
      resources[query] = result;

      return result;
    } catch (error) {
      if (axios.isCancel(error)) {
        return "axios_cancel";
      } else {
        return "an error occurred";
      }
    }
  };
};

export const parseAssetTypeNameToNumber = (assetTypeName) => {
  switch (assetTypeName) {
    case "stock":
      return 1;
    case "forex":
      return 2;
    case "crypto":
      return 3;
    default:
      return 0;
  }
};

export const translateAssetTypeName = (assetTypeName) => {
  switch (assetTypeName) {
    case "forex":
      return "Moedas";
    case "crypto":
      return "Criptomoedas";
    default:
      return "Ações";
  }
};

export const search = makeRequestCreator();

export function uncapitalize(text) {
  return text && text[0].toLowerCase() + text.slice(1);
}
